import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Filters } from '../components/Filters'
import { toggleFilter, setActiveFilter, resetFilters, setActiveTagFilter } from '../actions/radarSettings'
import { setAssessmentStatusVisible } from '../actions/radarSettings'

export default connect(
    state => {
        const {
            phenomenaTypes,
            filters: {
                filtersVisible,
                activeFilter,
                activeTagFilter,
                showAssessmentStatus
            },
            radarSettings: {
                group,
                radarLanguage,
                votingOn,
                ratingsOn,
                commentsOn,
                id: radarId
            }
        } = state

        return {
            phenomenaTypes,
            filtersVisible,
            activeFilter,
            activeTagFilter,
            showAssessmentStatus,
            votingOn,
            ratingsOn,
            commentsOn,
            group,
            radarId,
            language: radarLanguage
        }
    },
    dispatch => bindActionCreators({
        toggleFilter,
        setActiveFilter,
        resetFilters,
        setActiveTagFilter,
        setAssessmentStatusVisible
    }, dispatch)
)(Filters)
